<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@/api/models/auth/ability";
import { canOpenBillingPage, readBillingRights } from "@/composables/shared/billingAccess";
import BillingShell from "@/components/models/billing/BillingShell.vue";
import PayoutsSection from "@/components/models/billing/PayoutsSection.vue";

definePage({
  meta: {
    title: "generic.fields.sections.payouts",
    checkPrivileges: () => {
      const { can } = useAbility();
      return canOpenBillingPage(readBillingRights(can), "payouts");
    },
  },
});
</script>

<template>
  <billing-shell page="payouts">
    <template #default="{ scope, mso, company, canManageBilling }">
      <payouts-section
        v-if="scope === 'mso' && mso"
        :key="`mso-${mso.id}`"
        scope="mso"
        :owner-id="mso.id"
        :can-manage="canManageBilling"
      />

      <payouts-section
        v-else-if="scope === 'company' && company"
        :key="`company-${company.id}`"
        scope="company"
        :owner-id="company.id"
        :can-manage="canManageBilling"
      />
    </template>
  </billing-shell>
</template>
